import { Avatar, AvatarProps } from "antd";
import clsx from "clsx";
import React from "react";
import { OtherUtil } from "utils/other";
import "./UserInfo.style.scss";

type P_Props = AvatarProps & {
  title: string;
  subTitle?: string;
  bold?: boolean;
  onClick?: () => void;
};

const UserInfoPresenter = React.forwardRef((props: P_Props, ref: any) => {
  const { title, subTitle, onClick, ...avatarProps } = { ...props };

  return (
    <div ref={ref} className={clsx({ "user-info": true })} onClick={onClick}>
      <Avatar {...avatarProps} style={{ flex: "0 0 30px" }}>
        {!props.src ? OtherUtil.getFirstChar(title).toUpperCase() : ""}
      </Avatar>
      <div className="user-info__content">
        {props.title && (
          <div
            title={title}
            className={clsx({
              "user-info__content__title": true,
              "text-overflow-1-lines": !!subTitle,
              "text-overflow-2-lines": !subTitle,
              bold: props.bold,
              "c-pointer": Boolean(onClick),
            })}
          >
            {title}
          </div>
        )}
        {subTitle && <div className="user-info__content__subtitle">{subTitle}</div>}
      </div>
    </div>
  );
});

export default UserInfoPresenter;
